import React from "react";

import { AvatarImg } from "@/mk2/components/AvatarImg";
import { OverlayLoadable } from "@/mk2/components/OverlayLoadable";
import { Tooltip } from "@/mk2/components/Tooltip";
import useOverlay from "@/mk2/hooks/useOverlay";
import { UserEntity } from "@/mk2/schemas";

interface OwnProps {
    user: UserEntity;
    size: 16 | 18 | 24 | 28 | 32 | 36 | 40 | 50 | 150 | 200;
}

type Props = OwnProps;

const AvatarImgWithOverlay: React.FunctionComponent<Props> = ({ user, size }) => {
    const [
        showTooltip,
        onProductMouseEnter,
        onProductMouseLeave,
        productRef,
        getProduct,
        bodyContainer,
    ] = useOverlay<HTMLDivElement>();

    return (
        <div ref={productRef} onMouseEnter={onProductMouseEnter} onMouseLeave={onProductMouseLeave}>
            <AvatarImg user={user} size={size} />
            <OverlayLoadable
                placement="top"
                show={showTooltip}
                container={bodyContainer}
                target={getProduct}
            >
                {({ props, arrowProps, placement }) => (
                    <Tooltip
                        placement={placement}
                        containerRef={props.ref}
                        style={props.style}
                        arrowRef={arrowProps.ref}
                        arrowStyle={arrowProps.style}
                    >
                        {user.username}
                    </Tooltip>
                )}
            </OverlayLoadable>
        </div>
    );
};

AvatarImgWithOverlay.displayName = "AvatarImgWithOverlay";

export default React.memo<Props>(AvatarImgWithOverlay);
